<div class="process-entry">
    <div class="legal-entity-name">
      <a class="primary-link" [routerLink]="[
          '/',
          'customer-spaces',
          customerSpaceId,
          'file-process',
          process.type,
          'legal-entities',
          process.legalEntityId,
          'processes'
        ]">
        {{ process.legalEntityName | shorten }}
      </a>
    </div>
    <div class="process-name">
      <a [routerLink]="[
          '/',
          'customer-spaces',
          customerSpaceId,
          'file-process',
          process.type,
          'legal-entities',
          process.legalEntityId,
          'processes',
          process.processId
        ]">
        {{ process.processPeriod | shorten:20 }}&ensp;{{ process.processName | shorten:32 }}
      </a>
    </div>
  </div>